import request from "./request";

export function apply() {
    return request({
      url: "/api/chatInvite/apply",
      method: "get"
    });
}

export function checkApply() {
    return request({
      url: "/api/chatInvite/checkApply",
      method: "get"
    });
}

export function createInvite(data) {
  return request({
    url: "/api/chatInvite/createInvite",
    method: "post",
    data
  });
}

export function delInvite(data) {
    return request({
        url: "/api/chatInvite/delInvite",
        method: "post",
        data
    });
}

export function inviteInfo() {
    return request({
      url: "/api/chatInvite/inviteInfo",
      method: "get"
    });
}

export function loadTimeList(data) {
    return request({
      url: "/api/chatInvite/timeList",
      method: "post",
      data
    });
}

export function loadAchieveList(query) {
    return request({
      url: "/api/chatInvite/achieveList",
      method: "get",
      params: query
    });
}

export function loadRewardList(query) {
  return request({
    url: "/api/chatInvite/rewardList",
    method: "get",
    params: query
  });
}